import * as React from "react";
import { formSetValue, formTriggerValidation, useCpFormValue } from "../../../gvc/testNewForm/utils";
import { Button } from "antd";
import { store } from "../../../../store";
import { useCpFormContext } from "../../../../components/form/useCpFormContext";
import { Mk8sInput } from "../../../../schema/types/mk8s/input/mk8s";
import { cloneDeep, get } from "lodash";
import { v4 as uuidv4 } from "uuid";

interface Props {
  name: string;
}
export const NodePoolCoreButton: React.FC<Props> = ({ name }) => {
  const { id: formId } = useCpFormContext();

  const labels = useCpFormValue(name);

  const hasCoreTag = React.useMemo(() => {
    return labels.some((l) => l.name === "cpln.io/nodeType" && l.value === "core");
  }, [name, labels]);

  if (hasCoreTag) {
    return null;
  }

  return (
    <Button
      type="default"
      className="ml-2"
      onClick={() => {
        const form = store.getState().form.instances[formId];
        const values: Mk8sInput = form.values as any;

        const labels = cloneDeep(get(values, name));
        labels.push({ id: uuidv4(), name: "cpln.io/nodeType", value: "core" });
        formSetValue(formId, name, labels);
        formTriggerValidation(formId);
      }}
      size={`small`}
    >
      Use this nodepool as BYOK core
    </Button>
  );
};
